import { IFreeInputableWrappedObject, instanceOfIFreeInputableWrappedObject } from "./IFreeInputableWrappedObject";

export interface IFreeInputableObject extends IFreeInputableWrappedObject {
  pasteText(value: string, isForcibly?: boolean): void;
  shouldInputFreeAll: boolean;
  shouldInputFreeSelfOrAll: boolean;
  getSelectedText(): string;
  overwriteText(value: string, isForcibly?: boolean): void;
  removeSelectedText(): void;
}

export function instanceOfIFreeInputableObject(instance: any): instance is IFreeInputableObject {
  return instance
    && (instance.pasteText !== undefined)
    && (instance.shouldInputFreeAll !== undefined)
    && (instance.shouldInputFreeSelfOrAll !== undefined)
    && (instance.getSelectedText !== undefined)
    && (instance.overwriteText !== undefined)
    && (instance.removeSelectedText !== undefined)
    && instanceOfIFreeInputableWrappedObject(instance);
}
